import React from "react";
import { Card, Row, Col } from "reactstrap";
import NumberFormat from "react-number-format";
class CardInfo extends React.Component {
  render() {
    let me = this,
    item = me.props.item;
    return (
      <Card className="py-2 card-border-none align-middle">
        <Row className="no-gutters">
          <Col xs={12} sm={12} md={12} xl={2}>
            <i className={`h3 text-primary text-muted ${item.icon}`} />
          </Col>
          <Col xs={12} sm={12} md={12} xl={10}>
            <div>
              <NumberFormat className="h3 text-primary"
                value={item.value || ""}
                displayType={"text"}
                thousandSeparator={" "}
              />{" "}
              {item.value !== "" ?item.simbol : "--"}{" "}
            </div>
            <div className="text-secondary">
              {" "}
              {item.title || ""} {item.periodo !== "" ? " en " + item.periodo : ""}
            </div>
          </Col>
        </Row>
      </Card>
    );
  }
}
export default CardInfo;
